<template>
  <div class="news">
    <Menu></Menu>
    <Tabber
      :tabberData="tabberData"
      :activeIndex="activeIndex"
      :tabTitle="tabTitle"
      @changeTabber="changeTabber"
    >
      <div class="newsWrap" slot="tabberContent">
        <ul v-show="!infoShow">
          <li
            class="newsList"
            v-for="item in newData"
            :key="item.id"
            @click="lookInfo(item)"
            @mouseover="active = item.id"
            @mouseout="active = 0"
          >
            <div class="newsListDesc">
              <div class="newsTime">
                <div class="newsTimeTxt">
                  <div class="box">
                    <div class="yearFont">{{ item.createTime | seTimeFilter("n") }}</div>
                    <div class="monthFont">{{ item.createTime | seTimeFilter("yr") }}</div>
                  </div>
                  <span class="newsLine"></span>
                </div>
              </div>
              <div class="newsTxt">
                <span class="newsTxtMain">{{ item.title }}</span>
                <span class="newsTxtSub">{{ item.textShow }}</span>
              </div>
            </div>
            <div class="newsListImg">
              <img :src="item.img" alt="" />
            </div>
          </li>
        </ul>
        <div class="pagination" v-show="!infoShow">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.pageNo"
            :page-size="query.pageSize"
            :total="pageTotal"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
        <div class="content" v-show="infoShow">
          <div class="title">
            <p>{{ data.title }}</p>
            <span>{{ data.createTime | seTimeFilter("sq") }}</span>
          </div>
          <div class="info" ref="text"></div>
        </div>
      </div>
    </Tabber>
  </div>
</template>
<script>
import config from "@/config/url.config";
import { getSysNews } from "@/api/manage";
import Menu from "../../components/menu/menu.vue";
import Tabber from "../../components/menu/tabber.vue";
export default {
  components: { Menu, Tabber },
  data() {
    return {
      active: false,
      infoShow: false,
      tabberData: [
        { id: "1", name: "公司新闻" },
        { id: "2", name: "行业动态" },
      ],
      activeIndex: "1",
      tabTitle: "新闻中心",
      newData: [],
      data: "",
      baseURL: config.baseURL,
      query: {
        pageNo: 1,
        pageSize: 5,
        sortType: "a",
      },
      pageTotal: 0,
    };
  },
  watch: {
    $route(to, form) {
      console.log('to',to,form);
      this.query.pageNo=1
      if (to.params.show) {
        this.infoShow = false;
      }
      this.activeIndex = to.params.id;
      this.newData = to.params.data;
      this.pageTotal = +to.params.total
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.activeIndex = this.$route.params.id;
  },
  mounted() {
    if (!this.$route.params.show) {//如果是从首页点击新闻跳转过来的，则显示新闻详情，否则显示新闻列表页
      if (this.$route.params.data) {
        this.lookInfo(this.$route.params.data);
      }
    }
    window.scrollTo(0, 0);
    this.getData();
  },
  methods: {
    handlePageChange(val) {
      this.query.pageNo=val
      this.getData()
    },
    async getData() {
      let res = await getSysNews({
        type: this.$route.params.id,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        sortType: "a",
      });
      if (res.data) {
        let replaceTxt = 'http://116.206.94.117:8195//uploading'
        let newTxt = 'http://101.89.182.189:8191//uploading'
        res.data.forEach((item) => {
          let url = item.sysPicture
            ? config.baseURL + item.sysPicture.fileUrl + item.sysPicture.newName
            : "";
          item.img = url;
          let aa = decodeURI(item.content).replace(new RegExp(replaceTxt,'g'),newTxt);
          var afstr = aa.replace(/<[^>]+>/g, "");
          afstr = afstr.replace(
            /(\s|&mdash;|&nbsp;|&ldquo;|&rdquo;|&hellip;)/g,
            ""
          ); //拿到展示的文本，
          item.showInfo = afstr;
          item.textShow = item.showInfo.substring(0, 69) + "...";
        });
        this.pageTotal = +res.total;
      }
      // console.log("res.data", res.data);
      this.newData = res.data;
    },
    async changeTabber(index) {
    //  console.log('切换');
      //this.activeIndex = index
      this.query.pageNo=1
      this.infoShow = false;
      let res = await getSysNews({
        type: index,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        sortType: "a",
      });
      if (res.data) {
        let replaceTxt = 'http://116.206.94.117:8195//uploading'
        let newTxt = 'http://101.89.182.189:8191//uploading'
        res.data.forEach((item) => {
          let url = item.sysPicture
            ? config.baseURL + item.sysPicture.fileUrl + item.sysPicture.newName
            : "";
          item.img = url;
          let aa = decodeURI(item.content).replace(new RegExp(replaceTxt,'g'),newTxt);
          var afstr = aa.replace(/<[^>]+>/g, "");
          afstr = afstr.replace(
            /(\s|&mdash;|&nbsp;|&ldquo;|&rdquo;|&hellip;)/g,
            ""
          ); //拿到展示的文本，
          item.showInfo = afstr;
          item.textShow = item.showInfo.substring(0, 69) + "...";
        });
        this.pageTotal = +res.total;
      }
    //  console.log('res',res);
      this.$router.push({
        name: "newsCenter",
        params: { id: index, data: res.data,total:res.total },
      });

      this.newData = res.data;
    },
    lookInfo(data) {
      let replaceTxt = 'http://116.206.94.117:8195//uploading'
      let newTxt = 'http://101.89.182.189:8191//uploading'
      window.scrollTo(0, 200);
      console.log("data", data, this.$refs["text"]);
      this.$refs["text"].innerHTML = "";
      this.infoShow = true;
      this.data = data;
      let text = decodeURI(this.data.content).replace(new RegExp(replaceTxt,'g'),newTxt);
      this.$refs["text"].innerHTML += text;
    },
  },
};
</script>
<style scoped>
.newsList {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 25px 0;
}
.newsTxt span {
  display: block;
}
.newsListDesc {
  align-items: flex-start;
  display: flex;
  width: 808px;
}
.newsListImg {
  width: 200px;
  height: 133px;
}
.newsListImg img {
  width: 100%;
  height: 100%;
}
.newsTxt {
  width: 640px;
}
.newsTxtMain {
  color: #000;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 14px;
}
.newsTxtSub {
  font-size: 14px;
  color: #000;
  line-height: 28px;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.box .yearFont{
  font-size: 22px;
  color:black
}
.box .monthFont{
  font-size: 18px;
  color:black
}
.newsTimeTxt {
  display: flex;
  align-items: center;
  font-size: 28px;
  color: #999;
  margin-top: 17px;
}
.newsTimeTxt span {
  vertical-align: middle;
}
.box{
  text-align: center;
}
.newsLine {
  display: inline-block;
  width: 34px;
    height: 1px;
    background: #bfbfbf;
  margin: 0 15px 0 15px;
}
.newsTimeTxtIcon {
  display: none;
  width: 38px;
  height: 38px;
  margin-top: 26px;
}
.newsListDesc:hover .newsLine{
  width: 50px;
  transition: 0.75s;
  background: rgb(143, 143, 143);
}
.newsLine{
  transition: 0.75s
}
.newsList {
  cursor: pointer;
}
.title {
  margin-bottom: 28px;
}
.title p {
  font-size: 28px;
  font-weight: 700;
  text-align: center;
}
.title span {
  color: #666;
  text-align: center;
  font-size: 14px;
  display: block;
  margin-top: 8px;
}
.info {
  width: 1000px;
}
</style>